import { useState } from 'react';

export function useFormFields(initialValues) {
  const [values, setValues] = useState(initialValues);
  const [touchedFields, setTouchedFields] = useState({});

  function updateField(fieldName, fieldValue) {
    setValues((currentValues) => ({ ...currentValues, [fieldName]: fieldValue }));
  }

  function markTouched(fieldName) {
    setTouchedFields((currentTouchedFields) => ({ ...currentTouchedFields, [fieldName]: true }));
  }

  function markAllTouched() {
    setTouchedFields(Object.fromEntries(Object.keys(initialValues).map((fieldName) => [fieldName, true])));
  }

  function resetFields() {
    setValues(initialValues);
    setTouchedFields({});
  }

  function bindInput(fieldName) {
    return {
      value: values[fieldName],
      onChange: (event) => updateField(fieldName, event.target.value),
      onBlur: () => markTouched(fieldName),
    };
  }

  return { values, touchedFields, updateField, markTouched, markAllTouched, resetFields, bindInput };
}